"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const react_redux_1 = require("react-redux");
const reducers_1 = require("../../reducers");
const PhonePreview_1 = require("../wizards/PhonePreview");
const react_responsive_1 = require("react-responsive");
const DeviceTransitionContainer = ({ children, device, displayOverviewModal, showPhonePreview, triggeredAnimation, }) => {
    const Fragment = React.Fragment;
    const overviewContainerAnimation = triggeredAnimation === 'duplicate' ? '' : displayOverviewModal;
    const overviewAnimationTime = 350;
    if (device === 'Desktop') {
        return (React.createElement("div", { style: {
                height: '100vh',
                width: '100%',
                backgroundColor: src_1.cloud,
                display: 'flex',
                overflow: 'hidden',
                animation: `${overviewContainerAnimation} 350ms ease-out`,
                position: 'absolute',
                zIndex: 2,
            }, id: "mainModalView" },
            React.createElement("div", { style: { flex: '1 1 769px', height: '100%', maxWidth: 769 } },
                React.createElement("div", { style: {
                        animation: `${displayOverviewModal} ${overviewAnimationTime}ms ease-out`,
                        display: displayOverviewModal !== 'closed' ? 'flex' : 'none',
                        height: '100%',
                        maxWidth: 769,
                        position: 'relative',
                        minWidth: 0,
                        overflowX: 'hidden',
                    }, id: "mainModalLeft" }, children)),
            React.createElement("div", { style: {
                    flex: '1 1 auto',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    position: 'relative',
                }, id: "mainModalRight" },
                React.createElement("div", { id: "phone-bezel", style: {
                        position: 'absolute',
                        top: (window.innerHeight - 755) / 2,
                        transform: `translateX(${showPhonePreview ? '0%' : `${(window.innerWidth - 784) / 2 + 368}px`})`,
                        transition: '350ms ease-out',
                    } },
                    React.createElement(react_responsive_1.default, { minWidth: 1140 },
                        React.createElement(PhonePreview_1.default, { device: device }))))));
    }
    else {
        return (React.createElement("div", { style: {
                zIndex: 2,
                position: 'absolute',
                height: '100%',
                width: '100%',
                display: displayOverviewModal !== 'closed' ? 'flex' : 'none',
                animation: `${displayOverviewModal} ${overviewAnimationTime}ms ease-out`,
                minWidth: 0,
            }, id: "mainModalLeft" }, children));
    }
};
const mapStateToProps = (state) => ({
    displayOverviewModal: reducers_1.getIsOverviewModalOpen(state),
    triggeredAnimation: reducers_1.getTriggeredAnimation(state),
    showPhonePreview: reducers_1.getShouldShowPhonePreview(state),
});
exports.default = react_redux_1.connect(mapStateToProps, {})(DeviceTransitionContainer);
